
export default {
  data() {
    return {

      form : {
                id : '',
                nama : '',
                tujuan : '',
                surat : '',
                judul : '',
                lokasi : '',
                file : null,
                status : '',
                kategori_id : '',
                keterangan : '',
                survey : '',
                rekomendasi : null,
                userId : '',
                createBy : '',
                createAt : '',
                editedAt : '',
                email       : '',
                rekomendasi_old : null,
                file_old : null
            },
     
      list_data : [],
      list_kategori : [],
      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_agree: false,
      mdl_publish: false,
      mdl_tolak: false,
      mdl_open: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_VerifikasiUsulan + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            kategori_id : this.kategori_id,
            userId : this.userId,
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(this.list_data);
      });
    },

    getKategori: function() {
        fetch(this.$store.state.url.URL_Kategori, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log('telasooooo')
        this.list_kategori = res_data;
        // console.log(this.list_kategori)
        });
    },


    addData : function() {
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      // formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)

      // console.log(formData);

      fetch(this.$store.state.url.URL_Usulan + "addData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },


    editData : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_Usulan + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(a, b, c){
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_VerifikasiUsulan + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, file : b, rekomendasi : c})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
        this.form.id = data.id
        this.form.nama = data.nama
        this.form.tujuan = data.tujuan
        this.form.surat = data.surat
        this.form.judul = data.judul
        this.form.lokasi = data.lokasi
        this.form.kategori_id = data.kategori_id
        this.form.file = this.form.file
        this.form.status = data.status
        this.form.keterangan = data.keterangan
        this.form.survey = data.survey
        this.form.rekomendasi = this.form.rekomendasi
        this.form.userId = data.userId
        this.form.createBy = data.createBy
        this.form.createAt = data.createAt
        this.form.file_old =  data.file
        this.form.rekomendasi_old =  data.rekomendasi
    },

    terima_data : function(){
      var formData = new FormData();
        formData.append('data', JSON.stringify(this.form))
      formData.append('rekomendasi', this.form.rekomendasi)


        fetch(this.$store.state.url.URL_VerifikasiUsulan + "terima_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menyetujui Usulan', 'blue', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
    },

    kembalikan_data : function(){
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("keterangan", this.form.keterangan);


        fetch(this.$store.state.url.URL_VerifikasiUsulan + "kembalikan_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Mengembalikan Usulan', 'warning', 'check_circle_outline');
            this.getView();
        });
    },

    publish_data : function(){
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("keterangan", this.form.keterangan);


        fetch(this.$store.state.url.URL_VerifikasiUsulan + "publish_data", {
            method: "POST",
            headers: {
            authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Publish Data', 'secondary', 'check_circle_outline');
            console.log(res_data);
            this.getView();
        });
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.form.userId = get_profile.profile.userId;
    this.form.email = get_profile.profile.email;
    this.getKategori();
    this.getView();
  },
}
